import MoreVert from '@mui/icons-material/MoreVert'
import React from 'react'
import {
  DropdownMenu,
  type DropdownMenuEvent,
  type DropdownMenuItem,
} from 'sutra/components'
import { KebabButton } from 'sutra/components/KebabButton/KebabButton'

import mixpanel from 'trackers/mixpanel'

export type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onCopyItem: () => void
  onCopyRow: () => void
  projectId: string
  title?: string
}

export const StatCardMenu: React.FC<Props> = ({
  open,
  onOpenChange,
  onCopyItem,
  onCopyRow,
  projectId,
  title,
}) => {
  const items: DropdownMenuItem[] = [
    { key: 'copy-item', label: 'Copy item' },
    { key: 'copy-row', label: 'Copy row' },
  ]

  const handleAction = (key: string, event: DropdownMenuEvent): void => {
    event.stopPropagation()
    switch (key) {
      case 'copy-item':
        onCopyItem()
        mixpanel.track('copy', {
          proj_uuid: projectId,
          value: 'summary-info-card',
          title,
        })
        break
      case 'copy-row':
        onCopyRow()
        mixpanel.track('copy', {
          proj_uuid: projectId,
          value: 'summary-info-panel',
        })
        break
    }
  }

  return (
    <DropdownMenu
      side="bottom"
      align="end"
      open={open}
      onOpenChange={onOpenChange}
      items={items}
      onAction={handleAction}
    >
      <KebabButton
        size="sm"
        aria-label="Stat card actions"
        onClick={(e) => e.stopPropagation()}
      >
        <MoreVert fontSize="small" />
      </KebabButton>
    </DropdownMenu>
  )
}
